module.exports = __webpack_public_path__ + "img/s1.023d18e4.png";